/*jshint esversion: 6 */
import { computedFrom } from 'aurelia-framework';
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AccountAPI } from '../../services/accountAPI';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';

@inject(Router, AuthService, AccountAPI, UserMessageService)
export class Affiliate {
  constructor(router, authService, accountApi, userMessageService) {
    this.accountApi = accountApi;
    this.router = router;
    this.authService = authService;
    this.userMessageService = userMessageService;
    this.saving = false;
    this.showAffiliateLink = false;
    this.showAffiliateLinkCode = false;
  }

  activate(params) {
    let account = this.authService.getAccount();

    if (account !== null && account.owner_user_id !== null) {
      this.account_owner_user_id = this.authService.getAccount().owner_user_id;
    } else {
      this.userMessageService.setUserMessage('user', 'Please set up account.');
      this.router.navigate('account');
    }
    this.loading = true;
    this.load();

    $('body').on('click', '#copyWebLinkButton', () => {
      let element =  document.getElementById('affiliateWebLink');
      element.select();
      document.execCommand('Copy');
      element.setSelectionRange(0, 0);
    });

    $('body').on('click', '#copyEmailLinkButton', () => {
      let element =  document.getElementById('affiliateEmailLink');
      element.select();
      document.execCommand('Copy');
      element.setSelectionRange(0, 0);
    });
  }

  attached() {
    this.affiliateList.activate(this.account_owner_user_id);
  }

  getData() {
    // Note: Keep this method in sync with similar code in account.js

    const data = {
      // Basic account fields
      'owner_user_id': this.authService.getUser().id,
      'org_name': this.orgName,
      'org_email': this.orgEmail,
      'org_phone': this.orgPhone,
      'website': this.website,
      'business_type': this.businessType,
      'business_type_detail': this.businessTypeDetail,
      'logo_file': this.logo_file,
      'mlink_return_url': this.mlinkReturnUrl,

      // Affiliate program fields
      'referred_by': this.referred_by,
      'joined_affiliate_program': (this.joined_affiliate_program !== null) ? this.joined_affiliate_program : new Date().toISOString(),
      'address_1': this.address_1,
      'address_2': this.address_2,
      'city': this.city,
      'state': this.state,
      'zipcode': this.zipcode,
      'ein': this.ein
    };

    return data;
  }

  load() {
    this.accountApi.getByOwner(
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  navigateLink(route) {
    this.router.navigate(route, { replace: true });
    this.onNavigate();
  }

  save() {
    if (this.validate()) {
      this.saving = true;
      this.accountApi.save(
        this.getData(),
        null,
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this));
    }
  }

  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);
    this.authService.setAccount(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
    }
    this.saving = false;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
  }

  setData(data) {
    // Note: Keep this method in sync with similar code in account.js

    // Basic account fields (preserved here for round-tripping)
    this.orgName = data.org_name;
    this.website = data.website;
    this.orgEmail = data.org_email;
    this.orgPhone = data.org_phone;
    this.logo_file = data.logo_file;
    this.businessType = data.business_type;
    this.businessTypeDetail = data.business_type_detail;
    this.mlinkReturnUrl = data.mlink_return_url;

    // Affiliate program fields
    this.accountActive = data.status == '2';
    this.showAffiliateLink = this.accountActive;
    this.showAffiliateLinkCode = data.joined_affiliate_program !== null;
    this.affiliateInfoLink = window.affiliate_info_url;
    this.affiliateLink = window.site_url + '/#/visitor/signup/' + data.link_id;
    this.affiliateLinkImg = window.site_url + '/images/magnfi-m.png';
    this.affiliateLinkCode = "<p><a href='" + this.affiliateLink + "' target='_blank' rel='noopener noreferrer'><img src='" + this.affiliateLinkImg + "' alt='magnfi.com' style='max-width: 50px'/></a></p>";
    this.affiliateTermsLink = window.affiliate_terms_url;
    this.referred_by = data.referred_by;
    this.joined_affiliate_program = data.joined_affiliate_program;
    this.address_1 = data.address_1;
    this.address_2 = data.address_2;
    this.city = data.city;
    this.state = data.state;
    this.zipcode = data.zipcode;
    this.ein = data.ein;
  }

  @computedFrom('joined_affiliate_program')
  get showAffiliateList() {
    let account = this.authService.getAccount();
    return account.joined_affiliate_program !== null;
  }

  @computedFrom('joined_affiliate_program')
  get showTermsAndConditions() {
    let account = this.authService.getAccount();
    return account.joined_affiliate_program === null;
  }

  @computedFrom('joined_affiliate_program')
  get saveButtonText() {
    let account = this.authService.getAccount();
    return account.joined_affiliate_program ? 'Update' : 'Become Affiliate Partner';
  }

  validate() {
    let pass = true;
    let isAffiliate = this.joined_affiliate_program !== null;

    if ((!this.address_1 || !this.address_1.trim()) && (!this.address_2 || !this.address_2.trim())) {
      this.userMessageService.setUserError('user', 'Mailing Address is required');
      pass = false;
    }

    if (!this.city || !this.city.trim()) {
      this.userMessageService.setUserError('user', 'City is required');
      pass = false;
    }

    if (!this.state || !this.state.trim()) {
      this.userMessageService.setUserError('user', 'State is required');
      pass = false;
    }

    if (!this.zipcode || !this.zipcode.trim()) {
      this.userMessageService.setUserError('user', 'Zipcode is required');
      pass = false;
    }

    if (!this.accept_terms_and_conditions && !isAffiliate) {
      this.userMessageService.setUserError('user', 'You must accept the terms and conditions');
      pass = false;
    }

    return pass;
  }
}
